import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer, { logoutUser } from "./Slice/Auth/authSlice";
import loadingReducer from "./Slice/Auth/loadingSlice";
import dashboardReducer from "./Slice/Dashboard/dashboardSlice";
import leftNavReducer from "./Slice/Dashboard/leftNavSlice";
import inboxReducer from "./Slice/Inbox/inboxSlice";
import inboxSettingsReducer from "./Slice/Inbox/inboxSettingsSlice";
import inboxAllReducer from "./Slice/Inbox/inboxAllSlice";
import inboxRecentReducer from "./Slice/Inbox/inboxRecentSlice";
import inboxInfoReducer from "./Slice/Inbox/inboxInfoSlice";
import InboxMessageReducer from "./Slice/Inbox/InboxMessageSlice";
import userDetailsReducer from "./Slice/User/userDetailsSlice";
import subscriptionReducer from "./Slice/Subscription/subscriptionSlice";
import settingsReducer from "./Slice/Settings/settingsSlice";
import contactsReducer from "./Slice/Contacts/contactsSlice";
import contactGroupsReducer from "./Slice/Contacts/contactGroupsSlice";
import labelsReducer from "./Slice/Contacts/labelsSlice";
import addFunctionsReducer from "./Slice/Settings/addfunctionsSlice";
import updateFunctionsReducer from "./Slice/Settings/updatefunctionsSlice";
import reportsReducer from "./Slice/Reports/ReportsSlice";
import categoryReportsReducer from "./Slice/Reports/CategoryReportsSlice";
import broadcastsReportReducer from "./Slice/Reports/BroadcastsReportSlice";
import templateReducer from "./Slice/Templates/templateSlice";
import templateCreationReducer from "./Slice/Templates/templateCreationSlice";
import workflowReducer from "./Slice/Workflow/workflowSlice";
import workflowRunsReducer from "./Slice/Workflow/workflowRunsSlice";
import catalogReducer from "./Slice/Catalog/catalogSlice";
import bulkMessageHistoryReducer from "./Slice/bulkMessageHistorySlice";
import bulkMessageCampaignReducer from "./Slice/bulkMessageCampaignSlice";
import broadcastsReducer from "./Slice/Broadcasts/broadcastsSlice";
import workspaceReducer from "./Slice/Workspace/workspaceSlice";
import notificationReducer from "./Slice/Settings/notificationSlice";
import twoFactorReducer from "./Slice/Settings/twoFactorSlice";
import scheduledMessagesReducer from "./Slice/Inbox/ScheduledMessageSlice";
import teamMemberChatReducer from "./Slice/Inbox/teamMemberChatSlice";
import composerActionsReducer from "./Slice/Inbox/composerActionsSlice";
import aiAssistStatusReducer from "./Slice/Inbox/aiAssistStatusSlice";
import inboxBulkSelectionReducer from "./Slice/Inbox/inboxBulkSelectionSlice";
import taskTemplatesReducer from "./Slice/Tasks/taskTemplatesSlice";
import tasksReducer from "./Slice/Tasks/tasksSlice";
import taskChatReducer from "./Slice/Tasks/taskChatSlice";
import taskActivityHistoryReducer from "./Slice/Tasks/taskActivityHistorySlice";
import quickRepliesReducer from "./Slice/Settings/quickRepliesSlice";
import contactProfileFieldsReducer from "./Slice/Settings/contactProfileFieldsSlice";
import callsReducer from "./Slice/Calls/callSlice";
import liveCallsReducer from "./Slice/Calls/liveCallsSlice";
import lifecycleStageReducer from "./Slice/Lifecycle/lifecycleStageSlice";
import teamMembersPanelReducer from "./Slice/Dashboard/teamMembersPanelSlice";
import aiAgentsReducer from "./Slice/AiAgents/aiAgentsSlice";

const appReducer = combineReducers({
  auth: authReducer,
  loading: loadingReducer,
  dashboard: dashboardReducer,
  leftNav: leftNavReducer,
  userDetails: userDetailsReducer,
  subscription: subscriptionReducer,
  inbox: inboxReducer,
  inboxSettings: inboxSettingsReducer,
  inboxAll: inboxAllReducer,
  inboxRecent: inboxRecentReducer,
  inboxInfo: inboxInfoReducer,
  settings: settingsReducer,
  contacts: contactsReducer,
  contactGroups: contactGroupsReducer,
  labels: labelsReducer,
  inboxMessage: InboxMessageReducer,
  addFunctions: addFunctionsReducer,
  updateFunctions: updateFunctionsReducer,
  template: templateReducer,
  // utility: utilityReducer,
  // marketing: marketingReducer,
  reports: reportsReducer,
  categoryReports: categoryReportsReducer,
  broadcastsReport: broadcastsReportReducer,
  templateCreation: templateCreationReducer,
  workflow: workflowReducer,
  workflowRuns: workflowRunsReducer,
  catalog: catalogReducer,
  bulkMessageHistory: bulkMessageHistoryReducer,
  bulkMessageCampaign: bulkMessageCampaignReducer,
  broadcasts: broadcastsReducer,
  workspace: workspaceReducer,
  notifications: notificationReducer,
  twoFactor: twoFactorReducer,
  scheduledMessages: scheduledMessagesReducer,
  teamMemberChat: teamMemberChatReducer,
  composerActions: composerActionsReducer,
  aiAssistStatus: aiAssistStatusReducer,
  inboxBulkSelection: inboxBulkSelectionReducer,
  taskTemplates: taskTemplatesReducer,
  tasks: tasksReducer,
  taskChat: taskChatReducer,
  taskActivityHistory: taskActivityHistoryReducer,
  quickReplies: quickRepliesReducer,
  contactProfileFields: contactProfileFieldsReducer,
  calls: callsReducer,
  liveCalls: liveCallsReducer,
  lifecycleStage: lifecycleStageReducer,
  teamMembersPanel: teamMembersPanelReducer,
  aiAgents: aiAgentsReducer,
});

// Resets every slice back to its own initialState once logout completes, so a
// different account logging in on the same tab never sees the previous
// account's data left over in memory.
const rootReducer = (state, action) => {
  if (action.type === logoutUser.fulfilled.type) {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types from serializable check
        ignoredActions: ['templates/sendTemplateMessage/pending', 'templates/sendTemplateMessage/rejected'],
        // Ignore these paths in the state
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        ignoredPaths: ['items.dates'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Expose store globally for debugging and state access
if (typeof window !== 'undefined') {
  window.store = store;
}
